import React from "react";

// Home blocks
import HomeWelcome from "../../components/patient2/home/HomeWelcome";
import HomeSearch from "../../components/patient2/home/HomeSearch";
import HomeNextAppointment from "../../components/patient2/home/HomeNextAppointment";
import HomeQuickActions from "../../components/patient2/home/HomeQuickActions";
import HomeRecentVisits from "../../components/patient2/home/HomeRecentVisits";
import HomeRecommendedDoctors from "../../components/patient2/home/HomeRecommendedDoctors";

export default function HomeScreen({
  userName,
  nextAppointment,
  recentVisits = [],
  recommendedDoctors = [],
  onSearch,
  onBookAppointment,
  onUploadDocument,
  onMessages,
  onMyDoctors,
  onSeeAllVisits,
  onSelectVisit,
  onSeeAllRecommended,
  onOpenDoctor,
}) {
  return (
    <div className="p2-home-root">
      {/* 1. Warm welcome */}
      <HomeWelcome name={userName} />

      {/* 2. Big search panel */}
      <HomeSearch onSearch={onSearch} />

      {/* 3. Next appointment */}
      <HomeNextAppointment appointment={nextAppointment} />

      {/* 4. Quick actions */}
      <HomeQuickActions
        onBook={onBookAppointment}
        onUploadDocument={onUploadDocument}
        onMessages={onMessages}
        onMyDoctors={onMyDoctors}
      />

      {/* 5. Recent visits */}
      <HomeRecentVisits
        visits={recentVisits}
        onSeeAll={onSeeAllVisits}
        onSelect={onSelectVisit}
      />

      {/* 6. Recommended doctors */}
      <HomeRecommendedDoctors
        doctors={recommendedDoctors}
        onSeeAll={onSeeAllRecommended}
        onOpenDoctor={onOpenDoctor}
      />
    </div>
  );
}
